import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

interface Role {
    active: number;
    createdAt: any;
    description: string;
    name: string;
    subsidiaryId: string;
    updatedAt: any;
}

interface RoleId extends Role {
    id: string;
}

@Injectable()
export class RoleService {

    roleCollection: AngularFirestoreCollection<Role>;
    roles: any;

    roleDocument: AngularFirestoreDocument<RoleId>;
    role: Observable<RoleId>;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.ROLE_COLLECTION;
    }

    postRole(roleObject: any) {
        this.roleCollection = this.afs.collection(this.collection);

        return this.roleCollection.add(roleObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getRoles() {
        this.roleCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', 1));

        this.roles = this.roleCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Role;

                const name = data.name;
                const description = data.description;

                return { id$, name, description };
            });
        }).map(object => object);

        return this.roles;
    }

    getRole(id$: string) {
        this.roleDocument = this.afs.doc(this.collection + '/' + id$);

        this.role = this.roleDocument.valueChanges();

        return this.role.map(object => object);
    }

    putRole(roleObject: any, id$: string) {
        this.roleCollection = this.afs.collection(this.collection);

        return this.roleCollection.doc(id$).update(roleObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    /*
    // Method to delete the register from DB
    delRole(id$: string) {
        this.roleDocument = this.afs.doc(this.collection + '/' + id$);

        return this.roleDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }
    */

    delRole(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        this.roleCollection = this.afs.collection(this.collection);

        return this.roleCollection.doc(id$).update({ active: 0, updatedAt: new Date() }).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

}
